import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("Kratos UI error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-kv-bg text-kv-off flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <div className="font-mono text-xs uppercase tracking-[0.24em] text-kv-royal">Unexpected error</div>
            <h1 className="mt-4 font-display text-3xl font-medium tracking-tight">Something went wrong.</h1>
            <p className="mt-4 font-body text-sm text-kv-grey">Please reload the page. If the problem persists, contact us.</p>
            <button onClick={() => window.location.assign("/")} className="mt-8 px-6 py-3 bg-kv-off text-kv-bg border border-kv-off hover:bg-kv-navy transition-colors text-sm">
              Return home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
